<div class="toast toast-center toast-top">
	@for(notif of notifs(); track notif){
		<div class="alert" [ngClass]="getClass(notif)">
			<span>{{notif.text}}</span>
		</div>
	}
</div>
